import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../assets/logo-senado.svg';
import HomeMenu from '../homeMenu/index.js';
import React, { useState, useEffect } from 'react';
import {faBars} from '@fortawesome/free-solid-svg-icons';
import './index.css';
import SobreProjeto from '../sobreProjeto/index.js';
import { Link, useLocation } from 'react-router-dom';


export default function Header (props) {

    const [menuOpen, setMenuOpen] = useState(false);
    const handleMenuOpen = () => { setMenuOpen(true); };
    const handleMenuClose = () => {setMenuOpen(false);};

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const location = useLocation();
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);


    if (props.cor === 'preto') {
        return (
            <div>
                <header class="fixed top-0 left-0 w-full bg-transparent z-50">
                    <div className="header-home text-2xl">
                    <Link to="/">HOME</Link>
                        <button className={`${props.show? '' : 'none'}`} onClick={openModal} >SOBRE O PROJETO</button>
                        <SobreProjeto isOpen={isModalOpen} onClose={closeModal} />
                    </div>
                    <div className="header-menu-preto text-2xl">
                        <span>MENU</span>
                        <button class="text-4xl" onClick={handleMenuOpen} ><FontAwesomeIcon icon={faBars}/></button> 
                    </div>
                </header>
    
                <HomeMenu show={menuOpen} onClose={handleMenuClose} />
            </div>
        )
    }else{
        return (
            <div>
                <header>
                <Link to="/">
                    <img src={logo} alt='Logo senado' />
                </Link>
                    <div className="header-menu">
                        <span>MENU</span>
                        <button onClick={handleMenuOpen} ><FontAwesomeIcon icon={faBars}/></button> 
                    </div>
                </header>
    
                <HomeMenu show={menuOpen} onClose={handleMenuClose} />
            </div>
        )
    }
    
}